import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';

import ReactFallbackImage from 'react-image-fallback';

import Lightbox from 'js/components/lightbox';
import ProfileImage from 'js/components/profile_image';
import SocialUsernameLink from 'js/components/social_username_link';

import 'scss/layout.scss';
import './index.scss';

export default class PostsLightbox extends Component {
    static layouts = {
        default: 'default',
        content_only: 'content_only'
    };

    static propTypes = {
        handleFetchMorePosts: PropTypes.func,
        onPositionChange: PropTypes.func.isRequired,
        onClose: PropTypes.func,
        children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
        posts: PropTypes.arrayOf(
            PropTypes.shape({
                mediaUrl: PropTypes.string,
                caption: PropTypes.string,
                loadingCaption: PropTypes.bool,
                profilePictureUrl: PropTypes.string,
                platform: PropTypes.string,
                socialLinkId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                username: PropTypes.string
            })
        ),
        layout: PropTypes.string.isRequired,
        initialPosition: PropTypes.number.isRequired,
        fallbackImage: PropTypes.string
    };

    static defaultProps = {
        onPositionChange: () => {},
        layout: 'default',
        initialPosition: 0,
        handleFetchMorePosts: () => {}
    };

    constructor(props) {
        super(props);
        this.state = {
            position: props.initialPosition
        };
    }

    handleLeft = () => {
        const {position} = this.state;
        if (position > 0) {
            this.setState({position: position - 1});
        }
    };

    handleRight = () => {
        const {posts} = this.props;
        const {position} = this.state;
        if (position < posts.length - 1) {
            this.setState({position: position + 1});
        } else {
            this.props.handleFetchMorePosts();
        }
    };

    hasPosts = () => this.props.posts && !R.isEmpty(this.props.posts);

    UNSAFE_componentWillUpdate(nextProps, nextState) {
        if (nextState.position !== this.state.position) {
            this.props.onPositionChange();
        }
    }

    getChildrenWithInjectedProps = () => {
        if (this.hasPosts()) {
            const {children, posts} = this.props;
            const {position} = this.state;

            return React.Children.map(children, (child) =>
                React.cloneElement(child, {currentVisiblePost: posts[position]})
            );
        }
    };

    renderContent() {
        const {layout, posts, fallbackImage, loadingPosts} = this.props;
        const {position} = this.state;

        const {
            mediaUrl,
            caption,
            loadingCaption,
            profilePictureUrl,
            platform,
            socialLinkId,
            username,
            type
        } = posts[position];

        const children = this.getChildrenWithInjectedProps();

        const content =
            type === 'video' ? (
                <video controls src={mediaUrl} />
            ) : (
                <ReactFallbackImage src={mediaUrl} fallbackImage={fallbackImage || mediaUrl} />
            );

        if (loadingPosts) {
            return <div id="spinner" className="centered-spinner" />;
        }
        if (layout === PostsLightbox.layouts.default) {
            return (
                <div className="posts-lightbox">
                    <div className="posts-lightbox__content">{content}</div>
                    <div className="layout-stack posts-lightbox__sidebar layout-spread">
                        <div className="posts-lightbox__profile layout-middle">
                            <div className="posts-lightbox__avatar">
                                <ProfileImage imageUrl={profilePictureUrl} />
                            </div>
                            <div className="posts-lightbox__username">
                                <SocialUsernameLink platform={platform} socialLinkId={socialLinkId}>
                                    {username}
                                </SocialUsernameLink>
                            </div>
                        </div>
                        <div className="posts-lightbox__caption">
                            {loadingCaption ? 'Loading caption...' : caption}
                        </div>
                        <div className="posts-lightbox__controls">{children}</div>
                    </div>
                </div>
            );
        }

        if (layout === PostsLightbox.layouts.content_only) {
            return (
                <div className="posts-lightbox layout-stack content-only">
                    <div className="posts-lightbox__profile content-only layout-side-by-side">
                        <div className="posts-lightbox__avatar content-only">
                            <ProfileImage imageUrl={profilePictureUrl} />
                        </div>
                        <div className="posts-lightbox__username content-only">
                            <SocialUsernameLink platform={platform} socialLinkId={socialLinkId}>
                                {username}
                            </SocialUsernameLink>
                        </div>
                    </div>

                    <div className="posts-lightbox__content content-only">{content}</div>
                </div>
            );
        }
    }

    render() {
        const {onClose, lightboxClassName} = this.props;
        const {position} = this.state;

        if (!this.hasPosts()) {
            const {children} = this.props;

            return (
                <Lightbox className={lightboxClassName} onClose={onClose}>
                    {children}
                </Lightbox>
            );
        }

        return (
            <Lightbox
                onLeft={position > 0 ? this.handleLeft : null}
                className={lightboxClassName}
                onRight={this.handleRight}
                onClose={onClose}
            >
                {this.renderContent()}
            </Lightbox>
        );
    }
}



// WEBPACK FOOTER //
// ./components/posts_lightbox/index.js